import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = () => {
  return useQuery('subjects', async () => {
    const response = await service.get('/subjects');
    return response.data.data;
  });
};

export default useHook;
